const FIT_COLUMNS = new Set(["email_status", "phone_status", "linkedin_status", "campaign_status", "triage_status", "contact_history"]);
const PLACEHOLDERS = ".g-mut, .set-status";

function hasValue(cell: HTMLElement): boolean {
  const copy = cell.cloneNode(true) as HTMLElement;
  copy.querySelectorAll(PLACEHOLDERS).forEach((el) => el.remove());
  return (copy.textContent || "").replace(/—/g, "").trim() !== "";
}

function naturalWidth(table: HTMLTableElement, cells: HTMLElement[], header: boolean): number {
  const probe = document.createElement("table");
  probe.className = table.className;
  probe.setAttribute("aria-hidden", "true");
  probe.style.cssText =
    "position:absolute!important;left:-10000px!important;top:0!important;visibility:hidden!important;" +
    "width:max-content!important;min-width:0!important;max-width:none!important;table-layout:auto!important";
  const section = header ? probe.createTHead() : probe.createTBody();

  cells.forEach((cell) => {
    const clone = cell.cloneNode(true) as HTMLElement;
    clone.style.setProperty("width", "max-content", "important");
    clone.style.setProperty("min-width", "0", "important");
    clone.style.setProperty("max-width", "none", "important");
    section.insertRow().appendChild(clone);
  });

  (table.parentElement || document.body).appendChild(probe);
  const px = Math.max(0, ...Array.from(probe.querySelectorAll<HTMLElement>("td, th"), (c) => c.getBoundingClientRect().width));
  probe.remove();
  return Math.ceil(px);
}

// The narrowest a fitted column may be dragged: its widest value, or its header when every value is empty.
export function columnMinWidth(table: HTMLTableElement, key: string): number {
  if (!FIT_COLUMNS.has(key)) return 0;

  const cells = Array.from(table.querySelectorAll<HTMLElement>(`tbody td[data-col="${key}"]`)).filter(hasValue);
  if (cells.length) return naturalWidth(table, cells, false);

  const th = table.querySelector<HTMLElement>(`thead th[data-col="${key}"]`);
  return th ? naturalWidth(table, [th], true) : 0;
}
